import { NgModule } from "@angular/core";
import { LoaderComponentComponent } from "./loader-component/loader-component.component";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LoadingInterceptor } from "./loader-component/LoaderInterceptor";
import { ProgressBarModule } from "primeng/progressbar";
import { BrowserModule } from "@angular/platform-browser";
import { ProgressSpinnerModule } from "primeng/progressspinner";
  import { MyPrimeNgModule } from "./MyPrimeNGModule";
import { FileUploadModule } from "primeng/fileupload";
import { AmmazingGalleryComponent } from "../templates/ammazing-gallery/ammazing-gallery.component";
import { CommonModule } from "@angular/common";


@NgModule({
      imports: [CommonModule,ProgressBarModule,ProgressSpinnerModule,FileUploadModule,MyPrimeNgModule],
      declarations:[AmmazingGalleryComponent,LoaderComponentComponent],
      exports:[LoaderComponentComponent,AmmazingGalleryComponent],
      providers:[
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true }
      ],
})
export class GeneralSharedModule {}
